import * as React from 'react';

import TextField from '@mui/material/TextField';

interface TimeSelectorProps {
  value: string;
  label: string;
  onChange: (date: string) => void;
}

export const TimeSelector: React.FC<TimeSelectorProps> = (props) => {
  const { label, onChange, value } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const time = event.target.value;
    onChange(time);
  };

  return (
    <TextField
      type="time"
      value={value}
      onChange={handleChange}
      InputLabelProps={{
        shrink: true,
        className: 'relative transform-none text-gray-900 font-medium pb-1',
      }}
      InputProps={{ className: 'shadow-sm h-[57px]' }}
      label={label}
      fullWidth
    />
  );
};
TimeSelector.displayName = 'TimeSelector';
